// ColorContext.js
import React, { createContext, useState } from "react";

// Create the context
export const ColorContext = createContext();

// Provider component
export const ColorProvider = ({ children }) => {
    const [colorHex, setColorHex] = useState("#53ba8a"); // Default color ("explorting" from constants)

    return (
        <ColorContext.Provider value={{ colorHex, setColorHex }}>
            {children}
        </ColorContext.Provider>
    );
};
